/* eslint-disable prettier/prettier */
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  convertToOptions,
  ICON_COLOR,
  ICON_ID,
  ICON_KIND,
} from "@gcloud-npm/next12.components.icon";
import TextInfo, {
  TEXT_INFO_ALIGN,
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_KIND,
  TEXT_INFO_SEGMENT,
  TEXT_INFO_SIZE,
  TEXT_INFO_HEADING_LEVEL,
} from "@gcloud-npm/next12.components.text-info";
import CustomLink from "@gcloud-npm/next12.components.custom-link";
import { faqItemCss } from "./styles";

export const VARIANT = {
  DEFAULT: "DEFAULT",
  WITH_BORDERS: "WITH_BORDERS",
};

const FaqItem = ({
  faqTitle,
  faqContent,
  isOpen,
  taggingInfo,
  options,
  variant,
  Icon,
  segment,
  index,
}) => {
  const [isFaqShow, setIsFaqShow] = useState(!!isOpen);
  const [chevronOptions, setChevronOptions] = useState({
    color: options?.default?.color?.icon,
  });
  const [titleOptions, setTitleOptions] = useState({
    color: options?.default?.color?.title,
  });
  const displayAnswerStatusCss = isFaqShow
    ? "faq-item__chevron-icon--opened"
    : "faq-item__chevron-icon";
  const displayContentCss = isFaqShow
    ? "faq-item__content--opened"
    : "faq-item__content";
  const curentTaggingInfo = {
    ...taggingInfo,
    componentProduct: `faqItem-${index}`,
    componentContent: isFaqShow ? "faq-plegar" : "faq-desplegar",
    componentVariation: "none",
    eventType: "click",
  };
  const onClickItem = () => {
    if (isFaqShow) {
      setIsFaqShow(false);
      setTitleOptions({
        ...titleOptions,
        color: options?.default?.color?.title,
      });
      setChevronOptions({
        ...chevronOptions,
        color: options?.default.color?.icon,
      });
    } else {
      setIsFaqShow(true);
      if (options.activated) {
        setTitleOptions({
          ...titleOptions,
          color: options?.activated?.color?.title,
        });
        setChevronOptions({
          ...chevronOptions,
          color: options?.activated?.color?.icon,
        });
      }
    }
  };
  if (!faqContent || !faqTitle) {
    return null;
  }
  return (
    <>
      <li
        className={`faq-item ${
          variant === VARIANT.DEFAULT
            ? "faq-item--with-bottom-border"
            : "faq-item--with-borders"
        }`}
      >
        <div className="clicable-gap">
          <CustomLink
            className="item_link"
            taggingInfo={curentTaggingInfo}
            onClick={onClickItem}
            title={faqTitle}
            ariaLabel={`Desplegable ${faqTitle}`}
            href=""
          >
            <div className="faq-item__header">
              <TextInfo
                text={faqTitle || ""}
                kind={TEXT_INFO_KIND.HEADING}
                level={TEXT_INFO_HEADING_LEVEL.H3}
                align={TEXT_INFO_ALIGN.LEFT}
                color={titleOptions.color}
                size={TEXT_INFO_SIZE.TITLE6}
                fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                className="faq-item__title"
                segment={segment}
              />
              <span className={displayAnswerStatusCss}>
                <Icon
                  id={ICON_ID.CheuronDown}
                  kind={ICON_KIND.MEDIUM}
                  size={16}
                  color={chevronOptions.color}
                  segment={segment}
                  layoutSize={{
                    h: 16,
                    w: 16,
                  }}
                />
              </span>
            </div>
          </CustomLink>
        </div>

        <div className={displayContentCss}>
          <TextInfo
            text={faqContent || ""}
            color={options?.content?.color || TEXT_INFO_COLOR.GREY_6}
            size={TEXT_INFO_SIZE.CAPTION1}
            segment={segment}
          />
        </div>
      </li>

      <style jsx>{faqItemCss}</style>
    </>
  );
};

FaqItem.propTypes = {
  /**
   * {
   * "info": "Booleano que nos permite abrir la pregunta po defecto"
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  isOpen: PropTypes.bool,
  /**
   * {
   * "info": "Titulo de la pregunta frecuente/faq,"
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqTitle: PropTypes.string.isRequired,
  /**
   * {
   * "info": "Respuesta de la  pregunta frecuente/faq. Es el texto que aparece cuando clickas sobre el titulo de cada  pregunta frecuente/faq.",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqContent: PropTypes.string.isRequired,
  /**
   * {
   * "info": "Etiqueta de seguimiento para analitica",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  taggingInfo: PropTypes.object.isRequired,
  /**
   * {
   * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  options: PropTypes.shape({
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está sin abrir",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    default: PropTypes.shape({
      color: PropTypes.shape({
        title: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
        icon: PropTypes.oneOf(Object.values(ICON_COLOR)),
      }),
    }).isRequired,
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está abierta",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    activated: PropTypes.shape({
      color: PropTypes.shape({
        title: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
        icon: PropTypes.oneOf(Object.values(ICON_COLOR)),
      }),
    }),
    /**
     * {
     * "info": "El contenido de la faq"
     * }
     */
    content: PropTypes.shape({
      color: PropTypes.oneOf(Object.values(TEXT_INFO_COLOR)),
    }),
  }).isRequired,
  /**
   * {
   * "info": "Dependiendo del tipo de "variant" se cambian los estilos del componente. Es un modificador",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  variant: PropTypes.oneOf(Object.values(VARIANT)).isRequired,
  // Icon: PropTypes.func.isRequired,
  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: PropTypes.oneOf(convertToOptions(TEXT_INFO_SEGMENT)),
};

FaqItem.defaultProps = {
  segment: TEXT_INFO_SEGMENT.GP,
  isOpen: false,
};

export default FaqItem;
